export const ValidationRule = {
  Required: "Це поле обов'язкове для заповнення",
  Pattern: {
    Email: "Невірно введений формат email",
    YouTube: "Невірний формат посилання на YouTube відео",
    Url: "Невірний формат посилання",
  },
};
